import { Component, OnDestroy, Renderer2 } from '@angular/core';
import { CommonModule } from "@angular/common";

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from './services/core/authentication.service';
import { TitleTagService } from './services/core/title-tag.service';
import { ApiConnectionService } from './services/core/api-connection.service';
import { AppService } from './services/app.service';
import { ConfigService } from './services/core/config.service';
import { Router, NavigationEnd, ActivatedRoute, Event } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';

import { interval } from "rxjs/internal/observable/interval";
import { startWith, switchMap } from "rxjs/operators";

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalLoginComponent } from './modals/modal-login/modal-login.component';
import { ModalRegisterComponent } from './modals/modal-register/modal-register.component';
import { ModalPasswordRecoveryComponent } from './modals/modal-password-recovery/modal-password-recovery.component';

import { Meta, Title } from "@angular/platform-browser";
import { environment } from 'src/environments/environment';

import { NgcCookieConsentService } from 'ngx-cookieconsent';
import { Subscription } from 'rxjs';

declare global {
	interface Window { _paq: any[]; }
}

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy {
	title = '';
	showModal: boolean;
	registerForm: FormGroup;
	submitted = false;
	topNavActive: any = false;
	interval: any;
	authorName: any = '';
	defaultAuthorName: any;
	activities: any = [];
	currentCheckRequest: any = false;
	baseUrl = ''
	cdnUrl = ''
	systemTitle = ''
	systemSlogan = ''
	systemKey = ''
	salesWebsite = '';
	loginUrl = ''
	profileUrl = ''
	portalUrl = ''
	apiUrl = ''
	loginModalActive = false;
	registerModalActive = false;
	urlParameters = {};
	loginModal: any = false;
	passwordRecoveryModalActive: any = false;
	listener;
	showRocket = false;
	toasts = [];
	unreadFeedbackCount: any = 0;

	currentOrganisation;
	organisations;
	showDropdown = false;

	stylesheet = "default";

	public showProfileDropdown = false;

	public currentUser: any;

	private statusChangeSubscription!: Subscription;
	private initializeSubscription!: Subscription;

	constructor(
		private formBuilder: FormBuilder,
		private router: Router,
		private documentTitle: Title,
		private documentMeta: Meta,
		private route: ActivatedRoute,
		private authenticationService: AuthenticationService,
		private appService: AppService,
		private apiConnectionService: ApiConnectionService,
		private configService: ConfigService,
		private modalService: NgbModal,
		private ngxLoader: NgxUiLoaderService,
		private renderer2: Renderer2,
		private titleTagService: TitleTagService,
		private ccService: NgcCookieConsentService
	) {
		let self = this;

		this.baseUrl = configService.get('front_url');
		this.loginUrl = configService.get('login_url');
		this.profileUrl = configService.get('profile_url');
		this.apiUrl = configService.get('api_url');
		this.portalUrl = configService.get('portal_url');
		this.cdnUrl = configService.get('cdn_url');
		this.systemTitle = configService.get('title');
		this.systemSlogan = configService.get('slogan');
		this.systemKey = configService.get('system_key');
		// this.defaultAuthorName = configService.get('default_author');
		this.salesWebsite = configService.get('sales_website');

		this.appService.setDefaultTitle(configService.get('page_title'));
		this.appService.setDefaultDescription(configService.get('page_description'));

		this.appService.setDefaultMeta();

		self.checkHashArguments().then(function () {
			self.getStylesheet();
			self.getCurrentUser();

			self.setCurrentUserListener();
			self.setAuthorDataListener();
			self.setActivitiesListener();
			self.setPageDataListener();

			self.setMetaTags();

			self.setToastListener();
		});

		self.appService.getCurrentOrganisation();
		self.appService.currentOrganisation.subscribe(data => {
			self.currentOrganisation = data;
			self.getOrganisations();
		});
	}

	getOrganisations() {
		let self = this;
		self.apiConnectionService.read('organisations').then(function (response) {
			self.organisations = response;
		});
	}

	toggleDropdown() {
		if (this.showDropdown === true) {
			this.showDropdown = false;
		} else {
			this.showDropdown = true;
		}
	}

	toTop() {
		(window as any).scroll({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
	}

	openToast(url: any) {
		if (url == this.route.snapshot['_routerState'].url) {
			window.location.reload();
		} else {
			this.router.navigate([url]);
		}
	}

	toggleMenu() {
		this.showProfileDropdown = !this.showProfileDropdown;
		if (this.showProfileDropdown) {
			setTimeout(() => {
				const clickListener = (event: MouseEvent) => {
					if (!(event.target as HTMLElement).closest('.profile-dropdown')) {
						this.showProfileDropdown = false;
						document.removeEventListener('click', clickListener);
					}
				};
				document.addEventListener('click', clickListener);
			});
		}
	}

	async checkHashArguments() {
		try {
			let search = location.hash.substring(1);
			let params = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');

			this.urlParameters = params;
		} catch (e) {

		}

		if (this.urlParameters['login'] && this.urlParameters['login'] == 1) {
			this.showLogin();
		}

		if (this.urlParameters['register'] && this.urlParameters['register'] == 1) {
			this.showRegisterModal();
		}
	}

	getCurrentUser() {
		let self = this;
		this.ngxLoader.start();
		this.authenticationService.getCurrentUser().then(function (data) {
			if (self.currentUser == false) {
				self.appService.isSsoLoggedIn();
			} else {
			}
			self.ngxLoader.stop();
		}).catch(function (data) {
			self.appService.isSsoLoggedIn();
			self.ngxLoader.stop();
		});
	}

	doEntreeLogin() {
		location.href = this.configService.get('front_url') + 'auth/authentication/entree';
	}

	setCurrentUserListener() {
		let self = this;
		self.authenticationService.data.subscribe(data => {
			if (Object.keys(data).length) {
				self.currentUser = data;
				self.appService.getActivities(data['id']);
				self.startActivityTracking();
			} else {
				self.currentUser = false;
			}
		});
	}

	setAuthorDataListener() {
		let self = this;
		self.appService.currentAuthorData.subscribe(data => {
			self.authorName = data['name'];
		});
	}

	setToastListener() {
		let self = this;
		self.appService.toasts.subscribe(data => {
			for (let key in data) {
				let found = false;
				for (let i = 0; i < self.toasts.length; i++) {
					if (self.toasts[i]['id'] == data[key]['id']) {
						found = true;
						break;
					}
				}
				if (found == false) {
					self.toasts.push(data[key]);
				}
			}
		});
	}

	changeOrganisation(value) {
		let self = this;
		this.apiConnectionService.read('users/setCurrentOrganisationId/' + value + '').then(function (response) {
			window.location.reload();
		});
	}

	searchOrganisation(event) {
		let keyword = event.target.value;
		keyword = keyword.toLowerCase();

		for (let key in this.organisations) {
			let searchString = JSON.stringify(this.organisations[key]);
			searchString = searchString.toLowerCase();

			if (searchString.indexOf(keyword) !== -1) {
				this.organisations[key].hidden = false;
			} else {
				this.organisations[key].hidden = true;
			}
		}
	}

	removeToast(id) {
		this.toasts = this.toasts.filter(item => item['id'] !== id);
		this.appService.removeToast(id);
	}

	removeActivityToast(id) {
		let self = this;

		this.removeToast(id);

		if (self.currentCheckRequest['checkRequestId']) {

			this.apiConnectionService.read('checkRequests/read/' + self.currentCheckRequest['checkRequestId']).then((response) => {

			}).catch((err) => {

			});
		}
	}

	setActivitiesListener() {
		let self = this;
		self.appService.activitiesData.subscribe(data => {
			try {
				let currentUrl = this.route.snapshot['_routerState'].url;
				for (let key in data['activities']['checkRequests']) {
					if (data['activities']['checkRequests'][key]['alertReaded'] != 1 && data['activities']['checkRequests'][key]['checkStatus'] == 'APPROVED') {
						self.currentCheckRequest = data['activities']['checkRequests'][key];

						let pos = self.toasts.map((toast) => { return toast['id']; }).indexOf('check-toast');

						if (pos === -1) {
							self.appService.addToast('check-toast', 'Nakijken', 'check');
						}

						return;
					}
				}

				self.unreadFeedbackCount = data['activities']['unreadFeedbackCount'];
				self.currentCheckRequest = false;
				return;
			} catch (e) {

			}
		});
	}

	setPageDataListener() {
		let self = this;
		self.appService.pageDocumentData.subscribe(data => {
			if (data['topNavActive'] === "active") {
				self.topNavActive = true;
			} else {
				self.topNavActive = false;
			}

			if (data['showLoginModal'] === true) {
				self.showLogin(data['isPreview']);
			} else {
				self.loginModalActive = false;
			}

			if (data['showRegisterModal'] === true) {
				self.showRegister();
			} else {
				self.loginModalActive = false;
			}

			if (data['showPasswordResetModal'] === true) {
				self.showPasswordReset();
			} else {
				self.loginModalActive = false;
				self.passwordRecoveryModalActive = false;
			}

			self.documentTitle.setTitle(data['title']);
			self.documentMeta.updateTag({ name: 'description', content: data['description'] });
		});
	}

	startActivityTracking() {
		let self = this;

		if (this.interval) {
			return;
		}

		let intervalObject = interval(10000)
			.pipe(
				startWith(0),
				switchMap(function () {
					if (self.currentUser['id']) {
						return self.appService.getActivities(self.currentUser['id']);
					} else {
						return [];
					}
				})
			);

		this.interval = intervalObject.subscribe();
	}

	showLoginModal() {
		this.appService.showLoginModal();
	}

	showLogin(isPreview = false) {
		let self = this;

		if (self.loginModalActive === true) {
			return;
		}

		self.loginModalActive = true;

		self.loginModal = this.modalService.open(ModalLoginComponent);

		self.loginModal.componentInstance.isContentPreview = isPreview;

		self.loginModal.result.then((result) => {
			self.appService.hideLoginModal();
			self.appService.hideRegisterModal();
		}).catch(function (error) {
			self.appService.hideLoginModal();
			self.appService.hideRegisterModal();
		});
	}

	showPasswordReset() {
		let self = this;

		try {
			if (self.loginModal) {
				self.loginModal.close();
			}
		} catch (e) {

		}

		if (self.passwordRecoveryModalActive === true) {
			return;
		}

		self.passwordRecoveryModalActive = true;

		const passwordResetModal = self.modalService.open(ModalPasswordRecoveryComponent, { size: 'lg' });
		passwordResetModal.result.then((result) => {
			self.appService.hidePasswordResetModal();
			self.appService.hideLoginModal();
		}).catch(function (error) {
			self.appService.hidePasswordResetModal();
			self.appService.hideLoginModal();
		});
	}

	showRegisterModal() {
		this.registerModalActive = false
		this.appService.showRegisterModal();
	}

	showRegister() {
		let self = this;

		if (self.registerModalActive === true) {
			return;
		}

		self.registerModalActive = true;

		const registerModal = this.modalService.open(ModalRegisterComponent, { size: 'lg' });
		if (this.urlParameters['externalHash']) {
			registerModal.componentInstance.registerHash = this.urlParameters['externalHash'];
		} else {
			registerModal.componentInstance.registerHash = '';
		}

		registerModal.result.then((result) => {
			self.appService.hideLoginModal();
			self.appService.hideRegisterModal();
		}).catch(function (error) {
			self.appService.hideLoginModal();
			self.appService.hideRegisterModal();
		});
	}

	ngOnInit() {
		this.ccService.destroy();
	}

	ngOnDestroy() {
		// unsubscribe to cookieconsent observables to prevent memory leaks
		this.statusChangeSubscription.unsubscribe();
		this.initializeSubscription.unsubscribe();
	}

	onUrlChange(ev) {
		if (ev instanceof NavigationEnd) {
			let url = ev.url;
			if (url.indexOf('index') != -1) {
				this.topNavActive = true;
			} else {
				this.topNavActive = false;
			}
		}
	}

	logout() {
		this.apiConnectionService.clearAccessTokens('login/logout').then(function (response) {
			this.clearRefreshToken();
			this.clearAccessToken();

			this.authenticationService.logout();
		}).catch(function (response) {
			window.location.reload();
		});
	}

	getCurrentYear() {
		let date = new Date();
		return date.getFullYear();
	}

	setMetaTags() {
		this.titleTagService.setSocialMediaTags(this.configService.get('front_url'), this.configService.get('system_name'), this.configService.get('page_description'), this.configService.get('intro_image_url'));
	}

	splitHeader() {
		if (environment.frontStyle == "method") {
			return true;
		} else {
			return false;
		}
	}

	getStylesheet() {
		if (environment.frontStyle == "sections") {
			this.stylesheet = "sections";
		} else {
			this.stylesheet = "default";
		}
	}
}
